import { observeStore } from '@web-platform/shared-universal-redux/src/helpers/observeStore';
import { actUponMutationState } from '@web-platform/shared-universal-redux/src/network-layer/internals/actUponMutationState';
import { actUponQueryState } from '@web-platform/shared-universal-redux/src/network-layer/internals/actUponQueryState';
import { delayAndDebounce } from '@web-platform/shared-universal-utils-frontend/src/helpers/delayAndDebounce';
import { isAcornType } from '@web-platform/shared-universal-utils-frontend/src/helpers/isAcornRequest';

import type {
  StateType,
  ActionType,
  AcornStore,
  BananaStore,
} from '@web-platform/shared-universal-types/src/redux/state/state-shared-types';
import type { Store } from 'redux';

export function observeQueryChanges(store: Store<StateType, ActionType>): () => void {
  return observeStore(
    store,
    (state) => state.shared.network.queries,
    delayAndDebounce(actUponQueryState),
  );
}

export function observeMutationChanges(store: Store<StateType, ActionType>): () => void {
  return observeStore(
    store,
    (state) => state.shared.network.mutations,
    delayAndDebounce(actUponMutationState),
  );
}

export async function observeFatalError<TStore extends AcornStore | BananaStore>(
  store: TStore,
): Promise<() => void> {
  if (isAcornType<AcornStore, BananaStore>(store)) {
    const {
      actUponFatalError: actUponAcornFatalError,
      getMutationParameters: getAcornMutationParameters,
    } = await import(
      /* webpackChunkName: "Acorn-actUponFatalError" */
      '@web-platform/shared-acorn-redux/src/network-layer/actUponFatalRadarError/actUponFatalError'
    );
    return observeStore(
      store,
      (state) => getAcornMutationParameters(state),
      actUponAcornFatalError,
    );
  }
  const {
    actUponFatalError: actUponBananaFatalError,
    getMutationParameters: getBananaMutationParameters,
  } = await import(
    /* webpackChunkName: "Banana-actUponFatalError" */
    '@web-platform/shared-banana-redux/src//network-layer/actUponFatalRadarError'
  );
  return observeStore(
    store,
    (state) => getBananaMutationParameters(state),
    actUponBananaFatalError,
  );
}
